import { FC } from 'react'
import { IonRouterLink } from '@ionic/react'

import { getThumbnailImage } from '@/utils/url'

import { ActivityFeedVerb, ContestSections } from '@/enums'

const IMAGE_HEIGHT = 160

type CategorySlideProps = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  activity: any
}

const Channels = {
  [ActivityFeedVerb.ContestCreate]: ContestSections.Creator,
  [ActivityFeedVerb.ContestParticipate]: ContestSections.Participant,
}

export const CategorySlide: FC<CategorySlideProps> = ({ activity }) => {
  const imageSrc =
    activity.videoThumbnailSmall ||
    activity.attachments?.images?.[0] ||
    getThumbnailImage(activity.object?.data?.imageUrl)
  const imageRatio =
    activity?.imageAspectRatio ||
    activity?.imageRatios?.[0] ||
    activity.object?.data?.imageAspectRatio ||
    1

  const activityUrl = activity.contestId
    ? `/contest/${activity.contestId}/video/${activity.actor.id}?channel=${
        Channels[activity.verb]
      }&page=contest`
    : `/comments/${activity.id}?page=&replyId=`

  return (
    <IonRouterLink
      className="float-left flex-none cursor-pointer mr-3"
      routerLink={activityUrl}
    >
      <img
        src={imageSrc}
        className="bg-zinc-800 rounded-md"
        loading="lazy"
        style={{ height: IMAGE_HEIGHT, width: IMAGE_HEIGHT * imageRatio }}
      />
    </IonRouterLink>
  )
}
